export default __webpack_public_path__ + "static/media/message-send-icon.6b5069c2.svg";